import { motion } from "framer-motion";
import customerImage from "../assets/customerr.png";
import handImage from "../assets/hands.png";
import laptopGirlImage from "../assets/girl-laptop.png";
import sixPlusImage from "../assets/6plus.png";
import creativityImage from "../assets/creativity.png";
import underline from "../assets/underlinea.png";
import React, { useEffect, useState } from 'react';
import w from "../assets/W.png";
import i1 from "../assets/I1.png";
import i2 from "../assets/I2.png";
import bg from "../assets/BG.png";
import emojiLeft from '../assets/emoji-left.svg';
import emojiRight from '../assets/emoji-right.svg';
import emojiParty from '../assets/emoji-party.svg';
import emojiConfetti from '../assets/emoji-confetti.svg';
import { useNavigate } from 'react-router-dom'; 
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { Link } from 'react-router-dom';
import dd from "../assets/DD.png";
import ar from "../assets/Ar.png";
import ind from "../assets/Ind.svg";
import { ChevronDown } from "lucide-react";
import logo from "../assets/logo.png";
import { useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import sparkLeft from "../assets/spark-green.png";
import sparkRight from "../assets/spark-yellow.png";
import unnderline from "../assets/unnderline.png";
// import lenteraGroupedCards from '../assets/lentera-story-grouped.png';

 
 const cards = [
    {
      title: "Skills",
      desc: "“Our technical team represents more than 10+ years of software development experience. We are a very mixed group with expertise ranging from driver integration developments to Enterprise development.“",
    },
    {
      title: "Passion",
      desc: "“We just love software development – it's as simple as that. That love brings in the passion to create something amazing. . And the passion gives us the energy that drives us.“",
    },
    {
      title: "Process",
      desc: "“We are great believers of the Agile methodology in software development. Everything is bound to change and we are prepared for that change. We love to develop in small steps – giving our customers something to look at and give us feedback in at every stage.“",
    },
    {
      title: "Culture",
      desc: "“We are not just a place where software gets made. We see our space as a place for solving problems, for fun and creativity, for crafting things that are as simple to use as they are beautiful to look at. Our culture is open and without hierarchy.“",
    },
  ];
export default function LenteraStory() {
   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  const handleReload = () => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };
    const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );
 
      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
     setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
  
  const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
    const [isOpen, setIsOpen] = useState(false);
          
            // const toggleDropdown = () => {
            //   setIsOpen((prev) => !prev);
            // };
      
      
            const [isServicesOpen, setIsServicesOpen] = useState(false);
        const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
        const [isCompanyOpen, setIsCompanyOpen] = useState(false);
      
        // Toggle functions for dropdowns
        const toggleServicesDropdown = () => {
          setIsServicesOpen(!isServicesOpen);
          setIsIndustriesOpen(false);
          setIsCompanyOpen(false); // Close other dropdowns
        };
      
        const toggleIndustriesDropdown = () => {
          setIsIndustriesOpen(!isIndustriesOpen);
          setIsServicesOpen(false);
          setIsCompanyOpen(false); // Close other dropdowns
        };
      
        const toggleCompanyDropdown = () => {
          setIsCompanyOpen(!isCompanyOpen);
          setIsServicesOpen(false);
          setIsIndustriesOpen(false); // Close other dropdowns
        };
            const [word, setWord] = useState('Today');
      
        useEffect(() => {
          const interval = setInterval(() => {
            setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
          }, 2000);
          return () => clearInterval(interval);
        }, []);
    
    
    
      const stats = [
      {
        value: '98%',
        title: 'Quality of support',
        description: 'You don’t have a great business if you don’t have great customer support.',
      },
      {
        value: '100%',
        title: 'Ease of doing business',
        description: 'We pride ourselves on being a trusted partner to all of our customers.',
      },
      {
        value: '95%',
        title: 'Ease of use',
        description: 'Data management and governance shouldn’t be so painful. We make it easy.',
      },
    ];
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
      
    
      const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
      };
    
  return (
    <>
    <ToastContainer position="top-right" autoClose={3000} /><ToastContainer position="top-right" autoClose={3000} />
   
    <div className="top-0 z-50 w-full">
  <div className="relative bg-[#FFE9AC] py-2 px-3 text-center text-gray-800 text-[13px] sm:text-sm md:text-base font-medium flex items-center justify-center">
    
    {/* Left Emoji */}
    <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiLeft}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>

    {/* Center Text and Emojis */}
    <div className="flex flex-wrap items-center justify-center gap-1 px-6 text-center leading-tight">
      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>

     <span className="text-[11px] sm:text-[12px] md:text-[13px] leading-tight">
  We are proud to announce that we have completed&nbsp;
  <span className="text-green-700 font-semibold">6 successful years!</span>
</span>

      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiParty} alt="Party" className="h-4 w-4 sm:h-5 sm:w-5" />
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>
    </div>

    {/* Right Emoji */}
    <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiRight}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>
  </div>
</div>
 <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm">
            <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-2 md:px-8">
              {/* Logo */}
              <div className="flex items-center space-x-2">
                <Link to="/">
                  <img
                    src={logo}
                    alt="Lentera Logo"
                    className="h-8 w-auto"
                  />
                </Link>
              </div>
      
              {/* Hamburger Icon for Mobile */}
              <button
                className="lg:hidden flex items-center"
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
              >
                <svg
                  className="h-6 w-6 text-gray-800"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={isMobileMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
                  />
                </svg>
              </button>
      
              {/* Desktop Navigation */}
  <nav
      ref={navRef}
      className="hidden lg:flex items-center space-x-6 text-sm font-medium text-gray-800 ml-13"
    >
      {/* --- Services Dropdown --- */}
      <div className="relative">
        <div className="flex items-center gap-1">
          <a
            href="#"
            className="text-black hover:text-black flex items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown('services');
            }}
          >
            Services
            <img
              src={dd}
              alt="Dropdown arrow"
              className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                openDropdown === 'services' ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </a>
        </div>

        {openDropdown === 'services' && (
          <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              { to: "/services/ai-services/", label: "AI Services" },
              { to: "/services/web-development/", label: "Web Development" },
              { to: "/services/mobile-app-development/", label: "Mobile App Development" },
              { to: "/services/software-consulting/", label: "Software Consulting" },
              { to: "/services/third-party-integration/", label: "Third Party Integration" },
              { to: "/services/custom-development/", label: "Custom Development" },
              { to: "/services/enterprise-application/", label: "Enterprise Application" },
              { to: "/services/digital-transformation/", label: "Digital Transformation" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <div className="flex items-center">
                  <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="ml-2 text-xs">{item.label}</span>
                </div>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* --- Industries Dropdown --- */}
      <div className="relative">
        <div className="flex items-center gap-1">
          <a
            href="#"
            className="text-black hover:text-black flex items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown('industries');
            }}
          >
            Industries
            <img
              src={dd}
              alt="Dropdown arrow"
              className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                openDropdown === 'industries' ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </a>
        </div>

        {openDropdown === 'industries' && (
           <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              
              { to: "/industries/logistics/", label: "Logistics" },
              { to: "/industries/healthcare/", label: "Healthcare" },
              { to: "/industries/financial-services/", label: "Financial Services" },
              { to: "/industries/education/", label: "Education" },
              { to: "/industries/hospitality/", label: "Hospitality" },
              { to: "/industries/entertainment/", label: "Entertainment" },
              { to: "/industries/energy/", label: "Energy" },

            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <div className="flex items-center">
                  <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="ml-2 text-xs">{item.label}</span>
                </div>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* --- Company Dropdown --- */}
      <div className="relative">
        <div className="flex items-center gap-1">
          <a
            href="#"
            className="text-black hover:text-black flex items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown('company');
            }}
          >
            Company
            <img
              src={dd}
              alt="Dropdown arrow"
              className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                openDropdown === 'company' ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </a>
        </div>

        {openDropdown === 'company' && (
          <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              { to: "/company/our-advantages/", label: "Our advantages" },
              { to: "/company/our-story/", label: "Our Story" },
              { to: "/company/people-of-lentera/", label: "People of Lentera" },
              { to: "/company/our-brand/", label: "Our Brand" },
              { to: "https://blog.lentera.in/", label: "Blogs", external: true },
              { to: "https://www.lentera.in/contact-us/", label: "Support us", external: true },
              // { to: "/company/certifications/", label: "Certifications" },
            ].map((item) =>
              item.external ? (
                <a
                  key={item.to}
                  href={item.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                >
                  <div className="flex items-center">
                    <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    <span className="ml-2 text-xs">{item.label}</span>
                  </div>
                  <img
                    src={ar}
                    alt="Right arrow"
                    className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </a>
              ) : (
                <Link
                  key={item.to}
                  to={item.to}
                  className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                >
                  <div className="flex items-center">
                    <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    <span className="ml-2 text-xs">{item.label}</span>
                  </div>
                  <img
                    src={ar}
                    alt="Right arrow"
                    className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </Link>
              )
            )}
          </div>
        )}
      </div>

      {/* --- Contact Link --- */}
      <Link to="/contact/" className="text-black hover:text-black">
        Contact us
      </Link>
    </nav>
      
              {/* Desktop Language Selector + CTA */}
              <div className="hidden lg:flex items-center gap-3">
                {/* <button className="flex items-center gap-2 rounded-full border border-gray-300 px-4 py-1 text-sm font-medium text-gray-700 shadow-sm">
                  <img
                    src={ind}
                    alt="India Flag"
                    className="h-4 w-4 rounded-full"
                  />
                  India (English)
                  <ChevronDown className="h-4 w-4" />
                </button> */}
                 <button
  onClick={handleClick}
  className="w-[175px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
>
  Get a Free Quote
</button>

              </div>
            </div>
      
            {/* Mobile Menu */}
            {isMobileMenuOpen && (
              <div className="lg:hidden bg-white border-t border-gray-100">
                <nav className="flex flex-col px-4 py-4 space-y-2 text-sm font-medium text-gray-800">
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleServicesDropdown}
                    >
                      Services
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isServicesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isServicesOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/services/ai-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Ai Services
                        </Link>
                        <Link
                          to="/services/web-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Web Development
                        </Link>
                        <Link
                          to="/services/mobile-app-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Mobile App Development
                        </Link>
                        <Link
                          to="/services/software-consulting/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Software Consulting
                        </Link>
                        <Link
                          to="/services/third-party-integration/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Third Party Integration
                        </Link>
                        <Link
                          to="/services/custom-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Custom Development
                        </Link>
                        <Link
                          to="/services/enterprise-application/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Enterprise Application
                        </Link>
                         <Link
                          to="/services/digital-transformation/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Digital Transformation
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleIndustriesDropdown}
                    >
                      Industries
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isIndustriesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isIndustriesOpen && (
                      <div className="mt-2 space-y-1">
                       
                        <Link
                          to="/industries/logistics/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Logistics
                        </Link>
                        <Link
                          to="/industries/healthcare/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Healthcare
                        </Link>
                        <Link
                          to="/industries/financial-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Financial Services
                        </Link>
                        <Link
                          to="/industries/education/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Education
                        </Link>
                        <Link
                          to="/industries/hospitality/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Hospitality
                        </Link>
                        <Link
                          to="/industries/entertainment/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Entertainment
                        </Link>
                        <Link
                          to="/industries/energy/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Energy
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleCompanyDropdown}
                    >
                      Company
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isCompanyOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isCompanyOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/company/our-advantages/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our advantages
                        </Link>
                        <Link
                          to="/company/our-story/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Story
                        </Link>
                        <Link
                          to="/company/people-of-lentera/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          People Of Lentera
                        </Link>
                         <Link
                          to="/company/our-brand/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Brand
                        </Link>
                        {/* <Link
                        to="/company/certifications/"
                        className="block px-4 py-2 text-xs hover:bg-gray-100"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Certifications
                      </Link>   */}
                    <a
  href="https://blog.lentera.in/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Blogs
</a>

                        {/* <Link
                          to="/certifications"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Certifications
                        </Link> */}
                      <a
  href="https://www.lentera.in/contact-us/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Support us
</a>

                      </div>
                    )}
                  </div>
                  <Link
                    to="/Contact/"
                    className="block py-2 text-sm hover:bg-gray-100"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Contact us
                  </Link>
                  {/* <button className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700">
                    <img
                      src={ind}
                      alt="India Flag"
                      className="h-4 w-4 rounded-full"
                    />
                    India (English)
                    <ChevronDown className="h-4 w-4" />
                  </button> */}
          <button
                 onClick={handleClick}
  className="block py-2 text-sm font-semibold text-white bg-green-600 rounded-full hover:bg-green-700"
  // onClick={() => {
  //   const section = document.getElementById("contact-section");
  //   if (section) {
  //     section.scrollIntoView({ behavior: "smooth" });
  //   }
  // }}
>
  Get a Free Quote
</button>

                </nav>
              </div>
            )}
          </header>


 
<section className="relative w-full bg-white font-poppins px-4 sm:px-6 lg:px-8 py-16 overflow-hidden">
  
  <div className="relative max-w-screen-xl mx-auto h-auto">

    {/* Text Block */}
    <div className="w-full max-w-xl mx-auto text-center lg:text-center relative z-20">
      <p className="text-green-600 font-medium text-base">Our journey started with newbies</p>
      <img src={underline} alt="underline" className="mx-auto mt-2 w-36 h-3" />
      <h2 className="text-2xl sm:text-4xl md:text-5xl font-semibold mt-4 text-gray-900 leading-tight">
        The Lentera Story
      </h2>
      <p className="mt-4 text-gray-500 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto">
        We value strong client partnerships—and it shows. No one delivers innovative IT solutions quite like our team.
      </p>
    </div>

    {/* Desktop Grid */}
    <div className="hidden lg:grid grid-cols-5 gap-x-4 gap-y-6 mt-16">
      {/* Card 1 */}
      <div className="bg-[#DDF5E6] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[22rem]">
        <p className="text-lg font-medium">100+<br />Delighted customers</p>
        <img src={customerImage} alt="Customer" className="w-3/4 h-auto object-contain" />
      </div>

      {/* Card 2 (staggered down 16%) */}
      <div className="bg-[#F5F5F5] relative top-[6%] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[21rem]">
        <p className="text-lg font-medium">Professional minds,<br />simplified software</p>
        <img src={laptopGirlImage} alt="Laptop Girl" className="w-3/4 h-auto object-contain" />
      </div>

      {/* Card 3 (staggered down more) */}
      <div className="bg-[#FFE7F1] relative top-[28%] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[15rem]">
        <p className="text-lg font-medium">Delivering innovation<br />6+ years</p>
        <img src={sixPlusImage} alt="6+ Years" className="w-3/4 h-auto object-contain" />
      </div>

      {/* Card 4 (same as card 2) */}
      <div className="bg-[#FFF1E1] relative top-[5%] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[21rem]">
        <p className="text-lg font-medium">Driven by a culture<br />of creativity</p>
        <img src={creativityImage} alt="Creativity" className="w-3/4 h-auto object-contain" />
      </div>

      {/* Card 5 */}
      <div className="bg-[#E5D9FB] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[22rem]">
        <p className="text-lg font-medium">Passion-driven,<br />united by code</p>
        <img src={handImage} alt="Hands" className="w-3/4 h-auto object-contain" />
      </div>

      {/* Small Card 6 */}
      <div className="bg-[#FFE1E1] w-64 h-40 rounded-2xl p-4 flex flex-col justify-center items-center text-center mx-auto">
        <h3 className="text-2xl font-semibold">100%</h3>
        <p className="text-base">On time delivery accuracy<br />in all worked projects</p>
      </div>

      {/* Small Card 7 (staggered right bottom) */}
      <div className="bg-[#D7EEFF] top-130  w-64 h-40 absolute right-0 bottom-4 rounded-2xl p-4 flex flex-col justify-center items-center text-center">
        <h3 className="text-2xl font-semibold">24/7</h3>
        <p className="text-base">Providing valuable customer<br />support service</p>
      </div>
    </div>

    {/* Mobile Layout */}
    <div className="lg:hidden mt-12 space-y-8">
      {[customerImage, laptopGirlImage, sixPlusImage, creativityImage, handImage].map((img, idx) => (
        <div key={idx} className={`bg-white rounded-2xl p-4 flex flex-col justify-between items-center text-center h-auto ${idx >= 1 && 'mt-10'}`}>
          {/* Use proper conditional content */}
          <img src={img} alt="" className="w-3/4 h-auto object-contain" />
        </div>
      ))}
      {/* Small Cards below */}
      <div className="flex flex-wrap justify-center gap-6">
        <div className="bg-[#FFE1E1] w-64 h-40 rounded-2xl p-4 flex flex-col justify-center items-center text-center">
          <h3 className="text-2xl font-semibold">100%</h3>
          <p className="text-base">On time delivery accuracy<br />in all worked projects</p>
        </div>
        <div className="bg-[#D7EEFF] w-64 h-40 rounded-2xl p-4 flex flex-col justify-center items-center text-center">
          <h3 className="text-2xl font-semibold">24/7</h3>
          <p className="text-base">Providing valuable customer<br />support service</p>
        </div>
      </div>
    </div>
  </div>
</section>





 <section className="px-6 py-16 md:px-20 bg-white text-center font-poppins">
      <h2 className="text-3xl md:text-5xl font-medium text-gray-900 leading-tight">
        Principles we strongly <br className="hidden md:block" /> believe in
      </h2>
 <p className="text-gray-600 mt-4 max-w-2xl mx-auto text-[10px] md:text-sm">
  These core values guide our decisions, shape our culture, and drive everything we do.
</p>



      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-12 text-left">
        {/* Card 1 */}
        <div className="flex flex-col items-start text-left">
          <img src={i1} alt="Creativity" className="w-14 h-14 mb-4" />
          <h3 className="text-xl font-semibold text-gray-900">
            Culture of creativity
          </h3>
          <p className="text-gray-600 mt-3 text-[13px] leading-relaxed">
            Great software needs more than skill—it needs a creative culture. We empower independent teams and design spaces that inspire focus and innovation.
          </p>
        </div>

        {/* Card 2 */}
        <div className="flex flex-col items-start text-left border-t md:border-t-0 md:border-l border-gray-200 pt-8 md:pt-0 md:pl-10">
          <img src={i2} alt="Process" className="w-14 h-14 mb-4" />
          <h3 className="text-xl font-semibold text-gray-900">
            Geared process flow
          </h3>
          <p className="text-gray-600 mt-3 text-[13px] leading-relaxed">
            We believe in full transparency. Customers see daily progress, with access to everything from builds to task boards—enabling constant feedback and quick adjustments.
          </p>
        </div>
      </div>
    </section>

    
<section className="w-full font-poppins bg-white relative overflow-hidden">
      {/* Green Card Section */}
      <div className="bg-[#27ec88] pt-20 pb-36 rounded-b-[60px] relative z-10">
        {/* Heading */}
        <div className="text-center px-4 max-w-[960px] mx-auto mb-12">
          <h2 className="text-[32px] sm:text-[38px] font-bold text-[#141414] leading-tight">
            Four ingredients you need <br /> for amazing software
          </h2>
          <p className="text-[#1f1f1f] text-[16px] sm:text-[17px] mt-3">
            Skill, passion, process, and culture—four essentials for amazing software.
          </p>
        </div>

        {/* Card Grid */}
        <div className="max-w-[1320px] mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-[20px] h-[390px] p-6 shadow-[0px_15px_25px_-8px_rgba(0,0,0,0.08)] flex flex-col"
            >
              <h3 className="text-[18px] font-semibold italic text-black leading-tight">
                {card.title}
              </h3>
              <img src={underline} alt="underline" className="w-[70px] mt-1" />
              <p className="text-[#2e2e2e] text-[15px] mt-4 leading-relaxed">
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Black Brands Section - Pull Up Inside Green */}
      <div className="w-full bg-[#232323] text-white relative z-20 -mt-24 pt-20 pb-14">
        <div className="max-w-[980px] mx-auto px-4 text-center relative">
          {/* Spark icons */}
          <img
            src={sparkLeft}
            alt="spark-left"
            className="absolute left-0 top-0 w-[48px]"
          />
          <img
            src={sparkRight}
            alt="spark-right"
            className="absolute right-0 top-0 w-[48px]"
          />

          {/* Title */}
          <h2 className="text-white font-bold text-[24px] sm:text-[28px] mb-4">
            OUR BRANDS
          </h2>

          {/* Description */}
          <p className="text-[15px] sm:text-[16px] leading-relaxed">
            Our Lentera site proudly features products like Mawalog and Ticketzee,
            each specializing in unique, high-impact solutions. Mawalog excels in
            advanced gate control systems, while Ticketzee offers streamlined
            ticketing services.
          </p>
        </div>
      </div>
    </section>

<section className="flex flex-col md:flex-row items-center justify-between gap-10 px-6 md:px-20 py-20 max-w-7xl mx-auto font-[Poppins]">
  {/* Left Side: Just the Image */}
  <div className="w-full md:w-1/2 flex justify-center">
   <img
  src={w} // Replace with your actual image path or variable
  alt="Team Member"
  className="w-[430px] md:w-[500px] rounded-xl object-contain"
/>

  </div>

  {/* Right Side: Content */}
  <div className="w-full md:w-1/2">
    <div className="inline-block bg-[#D1FAE5] text-green-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
      Out strength
    </div>
    <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight mb-4">
      Strong technical skills are<br className="hidden md:block" /> our biggest asset
    </h2>
    <p className="text-sm md:text-base text-gray-700 leading-relaxed">
      We have wide experience both in development platforms and business domains. Over the years we have worked on projects ranging from trivial to immensely challenging and in the process have gained in-depth knowledge about different technology platforms. We hire only the best in the market and we have regular internal and external training sessions to keep us at the top of our profession.
    </p>
  </div>
</section>
 <section
      className="py-20 px-4 text-white font-poppins bg-cover bg-center"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-2">Customer Love</h2>
        <div className="w-24 h-[2px] bg-white mx-auto mb-12"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center items-start">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="relative px-4 md:px-6"
            >
              <div className="text-4xl font-semibold mb-2">{stat.value}</div>
              <h3 className="text-lg font-semibold mb-2">{stat.title}</h3>
              <p className="text-sm sm:text-base text-white">{stat.description}</p>

              {/* Vertical Divider for middle items on desktop */}
              {idx < stats.length - 1 && (
                <div className="hidden md:block absolute top-2 left-full h-full w-px bg-white opacity-30"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>

     <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
       {/* Top newsletter */}
       <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
         {/* Left Side */}
         <div className="flex items-start md:items-center gap-4 md:gap-6">
           <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
           <h2 className="text-xl md:text-[28px] font-bold leading-tight">
             Join our newsletter to <br className="hidden md:block" />
             keep up to date with us!
           </h2>
         </div>
 
   <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
  {/* Newsletter input */}
 <div
  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
  style={{ borderRadius: "6px" }}
>
  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
  <input
    type="email"
    value={email}
    onChange={handleChange}
    placeholder="Enter your email"
    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
  />
</div>
 
 
  {/* Captcha line (canvas + refresh + input + subscribe button) */}
{/* Outer wrapper to center the row */}
<div className="w-full flex justify-center">
  <div className="flex items-center gap-3">
    {/* Captcha canvas */}
    <div className="captcha-box">
      <canvas
        ref={canvasRef}
        id="captchaCanvas"
        width={60}
        height={40}
        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
      />
    </div>
 
    {/* Refresh button */}
    <button
      onClick={handleReload}
      style={{
        background: "#07862B ",
        color: "#fff",
        border: "none",
        padding: "6px",
        borderRadius: "6px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
      </svg>
    </button>
 
    {/* Captcha input */}
    <input
      type="text"
      placeholder="Enter captcha"
      value={userCaptcha}
      onChange={(e) => setUserCaptcha(e.target.value)}
      className="captcha-input"
    />
 
    {/* Subscribe button */}
    <button className="subscribe-button" onClick={handleSubscribe}>
      Subscribe
    </button>
  </div>
</div>
 
<style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>
 
</div>
       </div>
 
       {/* Divider */}
       <div className="border-t border-gray-700 w-full" />
 
       {/* Main Footer Content */}
       <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
         {/* Company Info */}
         <div className="w-full lg:w-[30%]">
           <a href="http://localhost:3000/" aria-label="Lentera Home">
  <img src={nlen} alt="Lentera logo" className="mb-6" />
</a>
           <p className="text-[#d4d4d4] leading-relaxed">
             We are highly experienced in offering software development, mobile
             application development, software consulting and project management
             delivery.
           </p>
           {/* Social Icons */}
           <div className="flex gap-4 mt-6 flex-wrap">
  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
    <img src={inst} alt="Instagram" className="w-8 h-8" />
  </a>
  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
    <img src={face} alt="Facebook" className="w-8 h-8" />
  </a>
  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={you} alt="YouTube" className="w-8 h-8" />
  </a>
  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
  </a>
  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
    <img src={twi} alt="X" className="w-8 h-8" />
  </a>
</div>

         </div>
 
         {/* Services */}
           <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
</ul>
         </div>
 
 
         {/* Insights */}
         <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
</ul>
         </div>
 
         {/* Contact */}
         <div className="w-full md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
          <div className="flex items-start gap-3 mb-3">
  <img src={phone} alt="phone" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Phone number</p>
    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
      +91-44-4856-3345
    </a>
  </div>
</div>

<div className="flex items-start gap-3 mb-3">
  <img src={mail} alt="email" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Email address</p>
    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
      info@lenteratech.com
    </a>
  </div>
</div>

           <div className="flex items-start gap-3">
  <img src={loc} alt="location" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Location</p>
    <a
      href="https://www.google.com/maps/place/G1,+Plot+No,+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white font-medium text-sm hover:underline block"
    >
      G1, Plot No, 824 and 826, 3rd<br />
      Main Rd, Ram Nagar South,<br />
      Madipakkam, Chennai,<br />
      Tamil Nadu 600091
    </a>
  </div>
</div>

         </div>
       </div>
     </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>


</>

  );
}
